import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const isTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nafn (lágstafir, engir sérstafir)',
    add: 'Bæta við',
    allowedFileTypes: 'Leyfðar skráargerðir',
    allowedFileTypesDescription:
      'Takmarka leyfilegar skráargerðir (t.d. mynd/*, forrit/pdf). Skildu eftir tómt til að leyfa allar tegundir.',
    allowMultipleFiles: 'Leyfa margar skrár',
    amountInCents: 'Upphæð í sentum',
    basePrice: 'Grunnverð',
    bcc: 'BCC',
    brand: 'Vörumerki',
    cc: 'CC',
    checkboxPlural: 'Reitir fyrir gátreit',
    checkboxSingular: 'Gátreitur',
    checkedByDefault: 'Merkt sjálfgefið',
    chooseConfirmationType:
      'Veldu hvort þú vilt birta skilaboð á síðu eða beina á aðra síðu eftir að þeir hafa sent inn eyðublaðið.',
    condition: 'Ástand',
    confirmationMessage: 'Staðfestingarskilaboð',
    confirmationType: 'Gerð staðfestingar',
    countryPlural: 'Country Fields',
    countrySingular: 'Land',
    creditCard: 'Kreditkort',
    customURL: 'Sérsniðin vefslóð',
    datePlural: 'Dagsetningarreitir',
    dateSingular: 'Dagsetning',
    defaultValue: 'Sjálfgefið gildi',
    divide: 'Skiptu',
    documentToLinkTo: 'Skjal til að tengja við',
    doesNotEqual: 'Er ekki jafn',
    emailFrom: 'Tölvupóstur frá',
    emailPlural: 'Tölvupóstreitir',
    emailsDescription:
      'Sendu sérsniðna tölvupósta þegar eyðublaðið er sent. Notaðu lista aðskilda með kommum til að senda sama tölvupóst til margra viðtakenda. Til að vísa til gildis úr þessu eyðublaði skaltu vefja nafn þess svæðis með tvöföldum krulluðum sviga, þ.e. {{firstName}}. Þú getur notað jokertákn {{*}} til að birta öll gögn og {{*:table}} til að forsníða þau sem HTML-töflu í tölvupóstinum.',
    emailSingular: 'Tölvupóstur',
    emailTo: 'Tölvupóstur til',
    equals: 'Jafnt',
    field: 'Field',
    fields: 'Fields',
    fieldWidth: 'Breidd reits (prósenta)',
    hasAnyValue: 'Hefur eitthvert gildi',
    internalLink: 'Innri hlekkur',
    label: 'Merki',
    maxFileSize: 'Hámarksskráarstærð (bæti)',
    maxFileSizeDescription: 'Hámarksskráarstærð í bætum. Skildu eftir tómt án takmarkana.',
    message: 'Skilaboð',
    messageDescription: 'Sláðu inn skilaboðin sem á að senda í þessum tölvupósti.',
    messagePlural: 'Skilaboðablokkir',
    messageSingular: 'Skilaboð',
    mimeType: 'MIME Tegund',
    mimeTypePlural: 'MIME gerðir',
    mimeTypeSingular: 'MIME Tegund',
    multiply: 'Margfalda',
    numberPlural: 'Númerareiti',
    numberSingular: 'Númer',
    optionPlural: 'Valmöguleikar',
    optionSingular: 'Valkostur',
    paymentFieldPlural: 'Greiðslureitir',
    paymentFieldSingular: 'Greiðsla',
    paymentProcessor: 'Greiðslumiðlari',
    paymentStatus: 'Staða',
    placeholder: 'Staðfestir',
    priceConditions: 'Verðskilmálar',
    priceConditionsPlural: 'Verðskilmálar',
    priceConditionsSingular: 'Verð ástand',
    radioOptions: 'Valkostir fyrir útvarpseiginleika',
    radioPlural: 'Útvarpsvellir',
    radioSingular: 'Útvarp',
    redirect: 'Tilvísun',
    replyTo: 'Svara til',
    required: 'Áskilið',
    selectOptions: 'Veldu Valkostir',
    selectPlural: 'Veldu Reitir',
    selectSingular: 'Veldu',
    statePlural: 'State Fields',
    stateSingular: 'Ríki',
    staticValue: 'Statískt gildi',
    subject: 'Efni',
    submitButton: 'Sendu hnappamerki',
    subtract: 'Dragðu frá',
    textareaPlural: 'Textarea Fields',
    textareaSingular: 'Textasvæði',
    textPlural: 'Textareitir',
    textSingular: 'Texti',
    title: 'Titill',
    token: 'tákn',
    uploadCollection: 'Hladdu upp safni',
    uploadCollectionDescription: 'Veldu hvaða upphleðslusafn til að geyma skrár í',
    uploadFieldPlural: 'Hlaða upp reitum',
    uploadFieldSingular: 'Hlaða upp',
    urlToRedirectTo: 'Slóð til að beina á',
    value: 'Gildi',
    valueOfField: 'Gildi vallar',
    valueType: 'Gildi Tegund',
  },
}

export const is: PluginLanguage = {
  dateFNSKey: 'is',
  translations: isTranslations,
}
